import { render } from "./DetailPembatalan.vue?vue&type=template&id=8145fb16&scoped=true"
import script from "./DetailPembatalan.vue?vue&type=script&lang=js"
export * from "./DetailPembatalan.vue?vue&type=script&lang=js"

import "./DetailPembatalan.vue?vue&type=style&index=0&id=8145fb16&lang=scss&scoped=true"

import exportComponent from "/Users/mymac/Documents/Digitala/Perki/newest-perki/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8145fb16"]])

export default __exports__